import { Card, Dropdown, FloatButton, Pagination, Tooltip } from 'antd'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { openNotification } from 'src/components/helpers/notification'
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { mailingsInfoListAction } from 'src/store/Slices/MailingsSlice'

const MobileMailingsContent = ({
    mailingsContentList,
    mailingsContentListLoading,
    setTab,
    mailingsContent,
    setMailingsContent,
    mnemo
}) => {

    const dispatch = useDispatch()

    return (
        <>
            {mailingsContentList?.data?.value?.rows.map(element => {
                return (
                    <Card
                        loading={mailingsContentListLoading}
                        title={`Рассылка №: ${element.id}`}
                        // extra={<Dropdown
                        //     menu={{
                        //         items,
                        //     }}
                        // >
                        //     <a onClick={() => { setAbonementInfo(element) }} className="text-primary text-decoration-none">
                        //         Действия <DownOutlined />
                        //     </a>
                        // </Dropdown>}
                        style={{ width: 330, marginTop: 16 }}
                        actions={[
                            <div onClick={() => {
                                setMailingsContent(element)
                                dispatch(mailingsInfoListAction({mailingId: element.id}))
                                setTab('Детали рассылки')
                            }}>Детали рассылки</div>,
                        ]}
                        key={element.id}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <div>№:</div>
                                <div>Заголовок:</div>
                                <div>Текст:</div>
                                <div>Кол-во клиентов:</div>
                                <div>Дата отправки:</div>
                                <div>Отправлено:</div>
                                <div>Тип:</div>
                            </div>
                            <div>
                                <div>{element?.id ? element?.id : '-'}</div>
                                <div>{element?.header ? <Tooltip title={element?.header}>{element?.header.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.body ? <Tooltip title={element?.body}>{element?.body.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.usersAmount ? element?.usersAmount : '-'}</div>
                                <div>{element?.supposedSendDate ? <Tooltip title={element?.supposedSendDate}>{element?.supposedSendDate.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.sendDate ? <Tooltip title={element?.sendDate}>{element?.sendDate.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.typeName ? element?.typeName : '-'}</div>
                            </div>
                        </div>
                    </Card>
                )
            })}
            {/* <FloatButton
                disabled={(!mnemo?.children?.find(el => el.name === 'Справочник')?.children.find(ele => ele.mnemo === 'insertBtn'))}
                style={{ right: 24 }}
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                    setIsOpenModal(true)
                }}
            /> */}
        </>
    )
}

export default MobileMailingsContent